import React, { useState, useEffect } from "react";
import AboutHero from "./AboutHero";
import AboutImpact from "./AboutImpact";
import JourneyTimeline from "./JourneyTimeline";
import PurposeVisionMission from "./PurposeVisionMission";


export default function Home() {

  return (
    <div>
   <AboutHero />
   <AboutImpact />
   <JourneyTimeline />
   <PurposeVisionMission />
    </div>
  );
}
